import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { branchHistory } from "../../api/directory";
import { HistoryPanel } from "./HistoryPanel";

// Collapsible change log for a branch: click to expand, filter by period.
export const BranchHistory = ({ branchId }) => {
  const { t } = useTranslation();
  const loader = useCallback(
    () => branchHistory(branchId).then((r) => r.items || []),
    [branchId]
  );
  return (
    <HistoryPanel
      title={t("branches.history.title")}
      hint={t("branches.history.hint")}
      emptyLabel={t("branches.history.empty")}
      loader={loader}
      rowNs="branches.history"
      testId="branch-history"
    />
  );
};
